export const INIT_FORGET_PASSWORD = 'forget_password';
export const COMPLETE_FORGET_PASSWORD = 'confirm';
